<template>
  <div>
    <el-dialog :visible.sync="localVisible" width="500px" @close="handleClose">
    <div class="qr-code-display">
      <div class="secret-key">
        <p v-if="data && data.merchantNo">{{ $t('clientmanage.table.merchantNo') }}:{{ data.merchantNo }}</p>
        <p v-if="data && data.merchantName">{{ $t('clientmanage.table.merchantName') }}:{{ data.merchantName }}</p>
        <p><span>{{ $t('clientmanage.addDialog.googleCode') }}:</span> {{ data.secret }}</p>
        <p v-if="data.merchantKey">{{ $t('merchantdetails.merchantkey') }}:{{ data.merchantKey }}</p>
      </div>
      <img :src="data.secretQr" alt="QR Code" class="qr-code-image" />
    </div>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'QrCodeModal',
  data() {
    return {
      localVisible: false,
      data:{}
    };
  },
  methods: {
    showModal(data) {
      this.data = data
      this.localVisible = true;
    },
    handleClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
.qr-code-display {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
}

.secret-key {
  font-size: 16px;
  color: #333;
  word-break: break-all;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/qrCodeModa/index.vue